import { render, staticRenderFns } from "./Dirfs.vue?vue&type=template&id=c99cbd3e"
import script from "./Dirfs.vue?vue&type=script&lang=js"
export * from "./Dirfs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports